import { combineReducers, configureStore, type Reducer } from '@reduxjs/toolkit';
import type { IInjectableStore } from '@redirecthealth/plan-factory-ui';

/** Host store with injectReducer, the contract rnav's store also offers to remotes. */
export function createHostStore(): IInjectableStore {
  const reducers: Record<string, Reducer> = {
    host: (state: { name: string } = { name: 'plan-factory-host' }) => state,
  };
  const store = configureStore({ reducer: combineReducers(reducers) });

  return Object.assign(store, {
    injectReducer(key: string, reducer: Reducer) {
      if (reducers[key]) return;
      reducers[key] = reducer;
      store.replaceReducer(combineReducers(reducers));
    },
  });
}
